// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_nvdZ1","content":"content_ylIkY"};